import { NgxLoadingButtonsModule } from 'ngx-loading-buttons';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SnCommonModule } from '@lib/common';
import { SnFormModule } from '@lib/form';
import { SnDragSlideToggleModule } from '@lib/form/drag-slide-toggle';
import { TranslationModule } from '@lib/translation';
import { SnButtonModule } from '@lib/ui/button';
import { SnIconModule } from '@lib/ui/icon';

import { DownloadVideoComponent } from './components/download-video/download-video.component';
import { SentryVaultComponent } from './components/sentry-vault.component';
import { SnVaultDialogComponent } from './dialogs/vault-dialog/vault-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    SnFormModule,
    SnCommonModule,
    MatDialogModule,
    MatTooltipModule,
    SnButtonModule,
    MatButtonModule,
    SnIconModule,
    MatProgressBarModule,
    MatInputModule,
    MatFormFieldModule,
    SnDragSlideToggleModule,
    NgxLoadingButtonsModule,
    TranslationModule,
  ],
  declarations: [
    SentryVaultComponent,
    DownloadVideoComponent,
    SnVaultDialogComponent,
  ],
  exports: [
    SentryVaultComponent,
    DownloadVideoComponent,
    SnVaultDialogComponent,
  ],
})
export class VaultModule {}
